export const formatPhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber) return '';

    return phoneNumber
        .replace(/[()]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/-$/, '')
        .trim();
};
